export default class DefaultAuthStrategy {
  constructor(authPort, storagePort) {
    this.authPort = authPort;
    this.storagePort = storagePort;
  }

  async login(credentials) {
    if (!credentials?.username || !credentials?.password) {
      throw new Error("Введите логин и пароль");
    }
    try {
      const response = await this.authPort.loginWithCredentials(credentials);

      if (!response._success) {
        throw new Error(response.message || "Ошибка авторизации");
      }

      if (response.authorizationToken) {
        await this.storagePort.setItem("token", response.authorizationToken);
      }

      return {
        success: true,
        message: "Авторизация прошла успешно",
        token: response.authorizationToken,
      };
    } catch (error) {
      console.error("DefaultAuthStrategy login error:", error);
      return {
        success: false,
        message: error.message || "Ошибка при входе",
      };
    }
  }
}
